var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuizIconBlueSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#176bfb;}.b,.c,.d,.f{fill:none;}.b,.c,.d{stroke:#fff;stroke-width:1.5px;}.b,.c{stroke-linecap:round;}.b,.d{stroke-linejoin:round;}.e{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-184.719 -354.563)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(184.719 354.563)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.56 360.18)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4.325,
    transform: "translate(7.045 2.201)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4.325,
    transform: "translate(7.045 8.807)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.881 7.486)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 2.642,
    y2: 2.642
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 2.642,
    y2: 2.642
  })), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 4.403,
    height: 4.403
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.75,
    y: 0.75,
    width: 2.903,
    height: 2.903
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIconBlueSmall);
export default __webpack_public_path__ + "static/media/quiz-icon-blue-small.94987915e02930d7682be381c5b4ad4a.svg";
export { ForwardRef as ReactComponent };